document.addEventListener('click', function (e) {

  // =========================
  // 1️⃣ 点击 reviews -> scroll 评论区
  // =========================
  const reviewEl = e.target.closest('.product__reviews');

  if (reviewEl) {
    const target = document.querySelector('.scm-reviews-importer');

    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }

    return; // ❗关键：停止继续执行
  }


  // =========================
  // 2️⃣ 点击 view features -> scroll next section
  // =========================
  const viewFeaturesBtn = e.target.closest('.product__view-features-button');

  console.log('viewFeaturesBtn', viewFeaturesBtn);

  if (viewFeaturesBtn) {

    const currentSection = viewFeaturesBtn.closest('section');
    let nextSection = currentSection?.nextElementSibling;

    // 确保是 section
    while (nextSection && nextSection.tagName !== 'SECTION') {
      nextSection = nextSection.nextElementSibling;
    }

    if (nextSection) {
      nextSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }
});



document.addEventListener("DOMContentLoaded", function () {

  function start(el) {
    const end = Date.parse(el.dataset.countdown);
    if (!end) return;

    const d = el.querySelector(".d");
    const h = el.querySelector(".h");
    const m = el.querySelector(".m");
    const s = el.querySelector(".s");

    function update() {
      let diff = end - Date.now();

      if (diff <= 0) {
        d.textContent = h.textContent = m.textContent = s.textContent = 0;
        return;
      }

      d.textContent = Math.floor(diff / 86400000);
      h.textContent = Math.floor(diff % 86400000 / 3600000);
      m.textContent = Math.floor(diff % 3600000 / 60000);
      s.textContent = Math.floor(diff % 60000 / 1000);
    }

    update();
    return setInterval(update, 1000);
  }

  const map = new Map();

  const io = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const el = entry.target;

      if (entry.isIntersecting && !map.has(el)) {
        map.set(el, start(el));
      }

      if (!entry.isIntersecting && map.has(el)) {
        clearInterval(map.get(el));
        map.delete(el);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll("[data-countdown]").forEach(el => {
    io.observe(el);
  });

});